import { render, staticRenderFns } from "./AcRemoteWidget.vue?vue&type=template&id=53de79a4"
import script from "./AcRemoteWidget.vue?vue&type=script&lang=js"
export * from "./AcRemoteWidget.vue?vue&type=script&lang=js"
import style0 from "./AcRemoteWidget.vue?vue&type=style&index=0&id=53de79a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports